import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { StrategyConditionalStepPatch } from 'crono-fe-common/types/DTO/strategyConditionalStepPatch';

export default function usePatchConditionalStrategyStep() {
  const queryClient = useQueryClient();

  const patchConditionalStep = (patch: StrategyConditionalStepPatch) => {
    const request: Request = {
      url: `${ENDPOINTS.strategy.conditional.main}`,
      config: {
        method: 'patch',
        data: { data: patch },
      },
    };
    return client(request);
  };

  return useMutation<Response<null>, CronoError, StrategyConditionalStepPatch>(
    patchConditionalStep,
    {
      onSettled: (_result, _error, _variables) => {
        queryClient.invalidateQueries([ENDPOINTS.strategy.search]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.main]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.details]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.usage]);
      },
    },
  );
}
